import React, { useState, useEffect } from "react";
import projectsService from "../../../services/projectsService.js";
import utilsHelper from "../../../helpers/utilsHelper.js";
import ModalProject from "./ModalProjects.js";
import SidebarNav from "../Sidebar/SidebarNav.js";
import LoadingContent from "../../public/LoadingContent.js";
import {useNavigate} from "react-router-dom";
import customDataService from "../../../services/customDataService.js";
import ModalCustomFieldFor from "../CustomFields/ModalCustomFieldFor.js";
import usePageAuthorization from "../../../helpers/usePageAuthorization.js";

const Projects = () => {

    const titleSingular = 'Proyecto';
    const titlePlural = 'Proyectos';
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingModal, setEditingModal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [customFields, setCustomFields] = useState([]);

    const [activeGroupModal, setActiveGroupModal] = useState(null);
    const [formCustomFieldsDataValues, setFormCustomFieldsDataValues] = useState({});
    const [visibleEditButton, setVisibleEditButton] = useState(false);
    const [visibleDeleteButton, setVisibleDeleteButton] = useState(false);
    const [visibleNewButton, setVisibleNewButton] = useState(false);

    const navigate = useNavigate();

    const { isAuthorized, isSuperAdmin } = usePageAuthorization({
        allowedRoles: ['Admin', 'Jefatura'],
        setLoading,
    });

    useEffect(() => {

        if (isAuthorized || isSuperAdmin) {
            setVisibleEditButton(true);
            setVisibleNewButton(true);
            setVisibleDeleteButton(true);
        }

        loadContent();
        loadCustomGroupFieldsSelectable();
    }, [isAuthorized, isSuperAdmin]);

    const loadContent = () => {
        setLoading(true);
        projectsService.getProjects().then(data => {
            setLoading(false);
            setData(data);
        });
    };

    const handleViewCustomField = (task) => {
        let customFieldsGroupsId = [];
        try {
            customFieldsGroupsId = JSON.parse(task.custom_fields_groups);
        } catch (e) { }

        customFieldsGroupsId.forEach(groupId => {
            customFields.forEach(item => {
                if(item.id === groupId) {
                    console.log(item.group_name);
                }
            });
        });

        //setFormCustomFieldsDataValues(JSON.parse(customFields.custom_fields_data_values) || {})
        //console.log(JSON.parse(customFields.custom_fields_groups));
        //setActiveGroupModal(customFields.custom_fields_groups[0]);
    };

    const loadCustomGroupFieldsSelectable = () => {
        customDataService.getCustomDataGroupsForSelectables().then(data => {
            setCustomFields(data);
        });
    };

    const handleOpenModalForCreate = () => {
        setEditingModal(null);
        setIsModalOpen(true);
    };

    const handleOpenModalForEdit = (data) => {
        setEditingModal(data);
        setIsModalOpen(true);
    };

    const handleRedirectToTask = (id) => {
        navigate(`/actividades/${id}`);
    };

    const handleRedirectToCustomFields = (item) => {
        navigate(`/programas/datos-personalizados/${item.id}`, {
            state: item
        });
    };

    const handleDelete = (id) => {
        if(window.confirm('¿Estás seguro que deseas eliminar este programa?')){
            setLoading(true);
            projectsService.deleteProject(id).then(data => {
                loadContent();
            });
        }
    };

    return (
        <div className="container-fluid" style={{background: 'url(/waves-white.png)'}}>
            <div className="row vh-100">

                <SidebarNav/>

                <div className="p-4 content-container col-md-9 col-lg-10">

                    {loading && (
                        <LoadingContent/>
                    )}

                    {!loading && (
                        <div>
                            <h3 className="mb-4 text-success">
                                <i className="bi bi-briefcase"></i> Administración de {titlePlural}
                            </h3>

                            {visibleNewButton && (
                                <button className="btn btn-success mb-3" onClick={handleOpenModalForCreate}>
                                    Crear Nuevo {titleSingular}
                                </button>
                            )}

                            <table className="table table-striped corner-radius">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Descripción</th>
                                    <th>Fecha de Inicio</th>
                                    <th>Fecha de Término</th>
                                    <th>Fecha de Creación</th>
                                    <th>Fecha de Actualización</th>
                                    <th>Estado</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {Array.isArray(data) && data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.project_name}</td>
                                        <td>{item.description}</td>
                                        <td>{utilsHelper.formatDate(item.started_at)}</td>
                                        <td>{utilsHelper.formatDate(item.deadline)}</td>
                                        <td>{utilsHelper.formatDate(item.created_at, true)}</td>
                                        <td>{utilsHelper.formatDate(item.updated_at, true)}</td>
                                        <td>
                                            <div className="color-palette-tilt" style={{backgroundColor: item.status_color || '#CCC'}}>
                                                {item.status || "Pendiente de Aprobación"}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="btn-group action-buttons">
                                                <button
                                                    disabled={item.status === ''}
                                                    className="btn btn-outline-success btn-sm"
                                                    onClick={() => handleRedirectToTask(item.id)}>
                                                    <i className="bi bi-list-task"></i>
                                                    <span>Actividades</span>
                                                </button>

                                                {visibleEditButton && (
                                                    <button
                                                        className="btn btn-success btn-sm"
                                                        onClick={() => handleOpenModalForEdit(item)}>
                                                        <i className="bi bi-pencil"></i>
                                                        <span>Editar</span>
                                                    </button>
                                                )}

                                                {visibleDeleteButton && (
                                                    <button
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => handleDelete(item.id)}>
                                                        <i className="bi bi-trash"></i>
                                                        <span>Borrar</span>
                                                    </button>
                                                )}

                                                <button
                                                    disabled={item.custom_fields_data_values == "" ? "disabled": ""}
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => handleRedirectToCustomFields(item)}>
                                                    <i className="bi bi-ui-checks"></i>
                                                    <span>Campos</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {isModalOpen && (
                        <ModalProject
                            isOpen={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            editingModal={editingModal}
                            loadContent={loadContent}
                            titleSingular={titleSingular}
                            customFields={customFields}
                        />
                    )}

                    {activeGroupModal && (
                        <ModalCustomFieldFor
                            group={activeGroupModal}
                            values={formCustomFieldsDataValues}
                            onChange={(data) =>
                                setFormCustomFieldsDataValues(data)
                            }
                            onClose={() => setActiveGroupModal(null)}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Projects;